export const fwLabelClass =
  'mb-1.5 block text-[13px] font-medium text-fw-ink'

export const fwInputClass =
  'h-[50px] w-full rounded-xl border border-fw-hairline bg-fw-pure px-3 text-base text-fw-ink placeholder:text-fw-muted outline-none transition-[border-color,box-shadow] duration-150 focus:border-fw-violet focus:shadow-fw-focus disabled:cursor-not-allowed disabled:bg-[#EDEFF4] disabled:text-fw-muted'

export const fwTextareaClass =
  'min-h-[120px] w-full rounded-xl border border-fw-hairline bg-fw-pure px-3 py-3 text-base text-fw-ink placeholder:text-fw-muted outline-none transition-[border-color,box-shadow] duration-150 focus:border-fw-violet focus:shadow-fw-focus resize-none'

export const fwSubmitClass =
  'inline-flex h-[52px] w-full min-h-11 items-center justify-center gap-2 rounded-xl bg-fw-violet px-4 text-[15px] font-semibold text-white shadow-fw-btn transition hover:bg-fw-violet-hover disabled:pointer-events-none disabled:bg-[#EDEFF4] disabled:text-fw-muted disabled:shadow-none'

export const fwInputErrorClass =
  'border-fw-error focus:border-fw-error focus:shadow-none'

export const fwSelectClass =
  'h-[50px] w-full appearance-none rounded-xl border border-fw-hairline bg-fw-pure px-3 text-base text-fw-ink outline-none transition-[border-color,box-shadow] duration-150 focus:border-fw-violet focus:shadow-fw-focus'

export const fwErrorClass =
  'inline-flex items-center gap-1.5 text-xs leading-snug text-fw-error-text'

export const fwConsentClass = 'text-xs leading-snug text-fw-graphite'

export const fwFormCardClass =
  'overflow-hidden rounded-[20px] border border-fw-hairline bg-fw-white shadow-fw-panel'
